import React from 'react';
import { Switch, Route } from 'react-router-dom';


import AccountScreen from './Account';
import BusinessScreen from './Business';
import TeamScreen from './Team';
import ApiAccessScreen from './ApiAccess';

export default function () {
  return (
    <Switch>
      <Route path="/parametres/compte">
        <AccountScreen />
      </Route>
      <Route path="/parametres/entreprise">
        <BusinessScreen />
      </Route>
      <Route path="/parametres/equipe">
        <TeamScreen />
      </Route>
      <Route path="/parametres/acces-api">
        <ApiAccessScreen />
      </Route>
    </Switch>
  );
}
